export function hasNullOrUndefined (obj) {
  if (!obj) return false

  return Object.values(obj).some(value => value == null)
}
